import {RunStates} from './runStates'


export const StateSaver = {
  saveState: (stateToSave) => {
    const copyOfStateToSave = Object.assign({}, stateToSave, { version: '1' })
    delete copyOfStateToSave.validationResult
  }
}

export const StateChanges = {
  // ** front end *
  RESET_STATE: 'RESET_STATE',
  RESET_RESULTS: 'RESET_RESULTS',
  SET_ENTIRE_STATE: 'SET_ENTIRE_STATE',
  SET_TEXT_FOR_API_CALL: 'SET_TEXT_FOR_API_CALL',
  SET_SENTENCE_TEXT_FOR_API_CALL: 'SET_SENTENCE_TEXT_FOR_API_CALL',
  SET_SEARCH_RESULTS: 'SET_SEARCH_RESULTS',
  SET_TYPE_AHEAD_RESULTS: 'SET_TYPE_AHEAD_RESULTS',
  SET_SENTENCE_RESULTS: 'SET_SENTENCE_RESULTS',
  SET_CURRENT_INDEX: 'SET_CURRENT_INDEX',
  SET_BIBLE: 'SET_BIBLE',
  SET_TALMUD: 'SET_TALMUD',
  // ** concerning APIs *
  SEARCH_NOT_RUN: 'SEARCH_NOT_RUN',
  SEARCH_RUNNING: 'SEARCH_RUNNING',
  SEARCH_TIMED_OUT: 'SEARCH_TIMED_OUT',
  SEARCH_FAILED: 'SEARCH_FAILED',
  SEARCH_COMPLETE: 'SEARCH_COMPLETE',
  // ** concerning APIs *
  TYPE_AHEAD_RUNNING: 'TYPE_AHEAD_RUNNING',
  TYPE_AHEAD_TIMED_OUT: 'TYPE_AHEAD_TIMED_OUT',
  TYPE_AHEAD_FAILED: 'TYPE_AHEAD_FAILED',
  TYPE_AHEAD_COMPLETE: 'TYPE_AHEAD_COMPLETE',
    // ** concerning APIs *
  SENTENCE_SEARCH_NOT_RUN: 'SENTENCE_SEARCH_NOT_RUN',
  SENTENCE_SEARCH_RUNNING: 'SENTENCE_SEARCH_RUNNING',
  SENTENCE_SEARCH_TIMED_OUT: 'SENTENCE_SEARCH_TIMED_OUT',
  SENTENCE_SEARCH_FAILED: 'SENTENCE_SEARCH_FAILED',
  SENTENCE_SEARCH_COMPLETE: 'SENTENCE_SEARCH_COMPLETE'  
}

export const Actions = {
  RUN_SEARCH: 'RUN_SEARCH',
  RUN_TYPE_AHEAD: 'RUN_TYPE_AHEAD',
  RUN_SENTENCE: 'RUN_SENTENCE'
}

export const BlankState = {
  searchApiState: RunStates.NOT_RUN,
  taApiState: RunStates.NOT_RUN,
  sentenceApiState: RunStates.NOT_RUN,
  textForApiCall: '',
  textForApiSentenceCall: '',
  typeAheadApiResponseBible: [],
  typeAheadApiResponseTalmud: [],
  bibleSearchApiResponse: [],
  talmudSearchApiResponse: [],
  showBible: true,
  showTalmud: false,
  verseId: '',
  currentIndex: 0,
  totalTalmudCount: 0,
  totalBibleCount: 0
}
